module.exports = __webpack_public_path__ + "media/images/icons/icon_mypage_donation_price_white-7c5bb4eed245db916a8621163181bb8e.svg";